import createApp from "./main";
import Worker from 'worker-loader!./web-worker'

const app = createApp(() => new Worker());

app.mount("#app");